<div>
  <app-form-manager
    [formPlugin]="data?.initialState?.formPlugin"
    [params]="data?.initialState?.params"
    (canceled)="closeModal()"
    (saveSucceed)="closeModal($event)"
    #form>
  </app-form-manager>
</div>
